<template>
  <div>

    <b-modal id="edit-records" hide-footer centered title="Edit Record" size="lg" >
      <p style="text-align: left;">To change typos or spelling of a Business, Location or Plot name click <a href="https://orders.crophealthlabs.net/#/editRecords">here.</a></p>
      <b-form-group style="text-align: left;" label="Field to Edit:" >
        <b-form-radio-group
          button-variant="outline-primary"
          v-model="edit.fieldToEdit"
          :options="['Business Location Plot', 'Variety Name', 'Crop']"
          buttons
        ></b-form-radio-group>
      </b-form-group>

      <div v-show="edit.fieldToEdit === 'Business Location Plot'">

        <b-form style="text-align: left;" @submit.prevent="saveEdit">          
          <b-form-group label="Search Business" label-for="business">
            <SearchList
              name="business"
              type="search"
              :list="business.list"
              @select-thing="selectItem($event, `business`)"
              @find-thing="filterRecords($event, 'business')"
              itemName="businessName"
              :state="null"
              required
            />
          </b-form-group>
          <p></p>

          <div v-show="location.show" style="margin-left: 2em;">
            <b-form-group label="Search Location" label-for="location">
              <SearchList
                name="location"
                type="search"
                :list="location.list"
                @select-thing="selectItem($event, `location`)"
                @find-thing="filterRecords($event, 'location')"
                itemName="locationName"
                :state="null"
                required
              />
            </b-form-group>
            <p></p>
          </div>

          <div v-show="plot.show" style="margin-left: 4em;">
            <b-form-group label="Search Plot" label-for="plot">
              <SearchList
                name="plot"
                type="search"
                :list="plot.list"
                @select-thing="selectItem($event, `plot`)"
                @find-thing="filterRecords($event, 'plot')"
                itemName="plotName"
                :state="null"
                required
              />
            </b-form-group>
            <p></p>
          </div>

          <b-form-group>
            <b-form-radio name="update" v-model="edit.selected" value="pair">Update only this Pair</b-form-radio>
            <b-form-radio name="update" v-model="edit.selected" value="selection">Update Current Selection</b-form-radio>
            <!-- <b-form-radio name="update" v-model="edit.selected" value="all">Update all Records</b-form-radio> -->
          </b-form-group>

          <b-button type="submit" >Save</b-button>
        </b-form>
      </div>

      <div v-show="edit.fieldToEdit === 'Crop'">
        <b-form style="text-align: left;" @submit.prevent="saveEdit">
          <b-form-group label="Search Crop" label-for="crop">
            <SearchList
              name="crop"
              type="search"
              :list="crop.list"
              @select-thing="selectItem($event, `crop`)"
              @find-thing="getCrops($event)"
              itemName="cropName"
              :state="null"
              required
            />
          </b-form-group>

          <b-form-group>
            <b-form-radio name="update" v-model="edit.selected" value="pair">Update only this Pair</b-form-radio>
            <b-form-radio name="update" v-model="edit.selected" value="selection">Update Current Selection</b-form-radio>
            <!-- <b-form-radio name="update" v-model="edit.selected" value="all">Update all Records</b-form-radio> -->
          </b-form-group>

          <b-button type="submit" >Save</b-button>
        </b-form>
      </div>

      <div v-show="edit.fieldToEdit === 'Variety Name'">
        <b-form style="text-align: left;" @submit.prevent="saveEdit">
          <b-form-group label="Search Variety" label-for="variety">
            <SearchList
              name="variety"
              type="search"
              :list="variety.list"
              @select-thing="selectItem($event, `variety`)"
              @find-thing="getCrops($event, 'variety')"
              itemName="varietyName"
              :state="null"
              required
            />
          </b-form-group>

          <b-form-group>
            <b-form-radio name="update" v-model="edit.selected" value="pair">Update only this Pair</b-form-radio>
            <b-form-radio name="update" v-model="edit.selected" value="selection">Update Current Selection</b-form-radio>
          </b-form-group>

          <b-button type="submit" >Save</b-button>
        </b-form>
      </div>

    </b-modal>

  </div>
</template>

<script>

import SearchList from "./SearchList";

import { ChlBusiness, Chlcrop, ChlLocation, ChlOrder, ChlPlot } from "../modules/orderInt";
import { mapActions, mapGetters, mapMutations } from "vuex";

export default {
  name: "edit-modal",
  props: {
    currentRecord: Object
  },  
  data() {
    return {
      edit: {
        selected: "pair",
        fieldToEdit: "Business Location Plot",
        newValue: ""
      },
      business: {
        list: [],
        selected: ""
      },
      location: {
        list: [],
        currentList: [],
        selected: "",
        show: false
      },
      plot: {
        list: [],
        currentList: [],
        selected: "",
        show: false
      },
      crop: {
        currentList: [],
        list: [],
        selected: ""
      },
      variety: {
        currentList: [],
        list: [],
        selected: "",
        cropName: null
      },
      typingTimer: 0
    };
  },
  methods: {
    async selectItem(id, name) {
      this[name].selected = this[name].list.find(x => x.id === id);
      this[name].list = [];
    
      if (name === "business") {
       
        let location = await ChlLocation.getCurrent(this.business.selected.id);
        if (!location.data.success) {
          this.location.list = [];
          return;
        }
        this.location.currentList = location.data.locations;
        
        this.location.show = true;
        this.location.list = this.location.currentList;
      }
      if (name === "location") {
        let plot = await ChlPlot.getCurrent(this.location.selected.id);
        if (!plot.data.success) {
          this.plot.list = [];
          return;
        }
        this.plot.currentList = plot.data.plots;
        
        this.plot.show = true;
        this.plot.list = this.plot.currentList;
      }
    },
    async filterRecords(string, name) {
      this[name].selected = "";

      if (name === "business") {
        this.location.show = false;
        this.plot.show = false;
        if (string.length < 3) {
          return;
        }
        // wait till the user finishes typing
        clearTimeout(this.typingTimer);
        await this.asyncTypingTimer(500);

        let business = await ChlBusiness.search(string);
        if (!business.data.success) {
          this.business.list = [];
          return;
        }
        this.business.list = business.data.farms;
      }

      if (name === "location") {
        this.plot.show = false;
        this.location.list = this.location.currentList.filter(x => x.locationName.toLowerCase().includes(string.toLowerCase()));
      }

      if (name === "plot") {
        this.plot.list = this.plot.currentList.filter(x => x.plotName.toLowerCase().includes(string.toLowerCase()));
  
      }
    },
    async saveEdit() {
      let externalIds = [];

      if (this.edit.selected === "pair") {
        externalIds.push(this.currentRecord.externalId);
      } else if (this.edit.selected === "selection") {
        if (!this.currentRecordList[0]) {
          return this.notify({
            message: "empty selection, please select some rows",
            variant: "warn"
          });
        }
        externalIds = this.currentRecordList;
      }

      let res;
      if (this.currentKey === "busLocPlot") {
        let businessId = this.business.selected.id;
        let locationId = this.location.selected.id;
        let plotId = this.plot.selected.id;
        res = await ChlOrder.update({fieldToEdit: this.currentKey, businessId, locationId, plotId, externalIds});

        let searchRes = this.currentSearchResults.map(x => externalIds.includes(x.externalId) ? {
          ...x, 
          businessId: this.business.selected.id, 
          businessName: this.business.selected.businessName,
          locationId: this.location.selected.id, 
          locationName: this.location.selected.locationName,
          plotId: this.plot.selected.id, 
          plotName: this.plot.selected.plotName
        } : x);

        this.setCurrentSearchResults(searchRes);
      }

      if (this.currentKey === "crop") {
        let cropId = this.crop.selected.id;
        res = await ChlOrder.update({fieldToEdit: this.currentKey, cropId, externalIds});

        let searchRes = this.currentSearchResults.map(x => externalIds.includes(x.externalId) ? {
          ...x, 
          cropId: this.crop.selected.id, 
          cropName: this.crop.selected.cropName
        } : x);

        this.setCurrentSearchResults(searchRes);
      }

      if (this.currentKey === "varietyName") {
        let varietyId = this.variety.selected.id;
        res = await ChlOrder.update({fieldToEdit: this.currentKey, varietyId, externalIds});

        let searchRes = this.currentSearchResults.map(x => externalIds.includes(x.externalId) ? {
          ...x, 
          varietyId: this.variety.selected.id, 
          varietyName: this.variety.selected.varietyName
        } : x);

        this.setCurrentSearchResults(searchRes);
      }

      this.notify({
        variant: res.data.success ? "success" : "warn",
        message: res.data.message
      });
      this.location.show = false;
      this.plot.show = false;
      this.$bvModal.hide("edit-records");
    },
    async getCrops(string, name) {
      if (name === "variety") {
        if (this.variety.currentList.length <= 0 || this.currentRecord.cropName !== this.variety.cropName) {
          let crops = await Chlcrop.getVariety(this.currentRecord.cropName);
          if (crops.data.success) {
            this.variety.currentList = crops.data.varieties;
            this.variety.cropName = this.currentRecord.cropName;
          }
        }
        this.variety.list = this.variety.currentList.filter(x => x.varietyName.toLowerCase().includes(string.toLowerCase()));
        return;
      }

      if (this.crop.currentList.length <= 0) {
        let crops = await Chlcrop.get();
        if (crops.data.success) {
          this.crop.currentList = crops.data.crops;
        }
      }
      this.crop.list = this.crop.currentList.filter(x => x.cropName.toLowerCase().includes(string.toLowerCase()));
    },
    asyncTypingTimer(time) {
      return new Promise(resolve => {
        this.typingTimer = setTimeout(() => {
          resolve();
        }, time);
      });
    },
    ...mapActions(["notify"]),
    ...mapMutations(["setCurrentSearchResults"])
  },
  computed: {
    currentValue() {
    
      if (!this.currentRecord) {
        return "";
      }

      return this.currentRecord[this.currentKey];
    },
    currentKey() {
      let map = {
        "Business Location Plot": "busLocPlot",
        "Variety Name": "varietyName",
        "Crop": "crop"
      };

      return map[this.edit.fieldToEdit];
    },
    ...mapGetters(["currentRecordList", "currentSearchResults"])
  },
  components: {
    SearchList
  },
  watch: {
    currentRecord() {
      this.getCrops("", "variety");
    }
  }
};
</script>

<style lang="sass" scoped>

</style>